import {useState, useEffect} from 'react';


const Notification = ({typeId}) => {

    let cases = [
        {
            id:1,
            title:"Task Error",
            message:"Internet not connected."
        },
        {
            id:2,
            title:"Task Error",
            message:"Please sit within camera range."
        },
        {
            id:3,
            title:"Task Error",
            message:"Oops! Something went wrong with data capture."
        },
        {
            id:4,
            title:"Task Failed",
            message:"Please restart the task to earn BAAI tokens."
        },
    ];

    // useEffect(() => {

    //     cases.map((item) => {
    //             if(item.id == typeId){
    //                     setCurrentCase(item)
    //             }
    //     })

    // },[typeId]);


    console.log(`current Error :${JSON.stringify(typeId)}`);


    return (
        <>
        
            <div className="warning-modal-style">
            <h4 
                style={{
                    fontFamily:"Archivo"
                }}
            >{cases[typeId-1]?.title}</h4>
            <p
                style={{
                    fontFamily:"Archivo",
                    fontSize:"18px"
                }}
            >
                {cases[typeId-1]?.message}
            </p>
            </div>

        </>
    );

}



export default Notification;